import { defineComponent as f, ref as _, watch as N, createElementBlock as r, openBlock as s, createCommentVNode as l, createElementVNode as i, createVNode as g, unref as m, toDisplayString as p } from "vue";
import { ScalarIconCaretLeft as k, ScalarIconCaretRight as y } from "@scalar/icons";
import { findPreviousPage as C, findNextPage as x } from "../helpers/pageNavigation.js";
const T = { class: "t-editor__page-nav" }, S = {
  key: 0,
  class: "t-editor__page-nav__container"
}, V = { class: "t-editor__page-nav__item-label" }, B = { class: "t-editor__page-nav__item-label" }, w = /* @__PURE__ */ f({
  __name: "PageNav",
  props: {
    activePage: {},
    sidebar: {}
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(c, { emit: P }) {
    const t = c, v = P, o = _(null), n = _(null);
    return N(
      [() => t.activePage, () => t.sidebar, () => {
        var a;
        return (a = t.sidebar) == null ? void 0 : a.items;
      }],
      () => {
        o.value = C(t.sidebar, t.activePage), n.value = x(t.sidebar, t.activePage);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (a, e) => {
      var d, u;
      return s(), r("div", T, [
        a.sidebar && (o.value || n.value) ? (s(), r("div", S, [
          o.value ? (s(), r("button", {
            key: 0,
            class: "t-editor__page-nav__item t-editor__page-nav__item-left",
            type: "button",
            onClick: e[0] || (e[0] = (b) => v("goToPrevPage", o.value))
          }, [
            i("div", V, [
              g(m(k)),
              e[2] || (e[2] = i("span", null, "Previous", -1))
            ]),
            i("b", null, p((d = a.sidebar.items[o.value]) == null ? void 0 : d.title), 1)
          ])) : l("", !0),
          n.value ? (s(), r("button", {
            key: 1,
            class: "t-editor__page-nav__item t-editor__page-nav__item-right",
            type: "button",
            onClick: e[1] || (e[1] = (b) => v("goToNextPage", n.value))
          }, [
            i("div", B, [
              e[3] || (e[3] = i("span", null, "Next", -1)),
              g(m(y))
            ]),
            i("b", null, p((u = a.sidebar.items[n.value]) == null ? void 0 : u.title), 1)
          ])) : l("", !0)
        ])) : l("", !0)
      ]);
    };
  }
});
export {
  w as default
};
